import {gql} from '@apollo/client';

export const PRODUCT_LIST_ITEM_FRAGMENT = gql`
    fragment ProductListItemFragment on ProductNotMine {
        id
        createdAt
        category
        title
        brand
        price
        status
        external_url
        resizedSmallImages
        is_visible
        size
        condition
        discount_rate
        like_count
        is_liked
    }
`;

export const PRODUCT_DETAILS_PRELOAD_FRAGMENT = gql`
    ${PRODUCT_LIST_ITEM_FRAGMENT}
    fragment ProductDetailsPreloadFragment on ProductNotMine {
        ...ProductListItemFragment
        description
    }
`;
